import { shallowEqual, useSelector } from 'react-redux';
import { getCasesSoundType } from '../ducks';

export const useGetCasesSoundType = () => ({
  soundType: useSelector(getCasesSoundType, shallowEqual),
});
